var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.997,
    height: 21,
    viewBox: "0 0 28.997 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "email-icon",
    d: "M1.7,0h25.69a1.67,1.67,0,0,1,1.653,1.665V19.321a1.653,1.653,0,0,1-.288.945.657.657,0,0,1-.156.236.619.619,0,0,1-.156.109,1.653,1.653,0,0,1-1.065.39H1.7A1.67,1.67,0,0,1,.05,19.347V1.665A1.67,1.67,0,0,1,1.7,0ZM1.632,18.619l8.686-9.026L1.632,2.253V18.619Zm9.995-7.9L2.346,19.708H26.671L17.8,10.72l-2.6,2.175h0a.638.638,0,0,1-.815,0ZM19.09,9.577l8.374,9.116V2.173Zm-16.64-8.3,12.323,9.988,11.78-9.988Z",
    transform: "translate(-0.05)",
    fill: "#186aa5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.84e35060b39053bf89d4749d0f5b5ba6.svg";
export { ForwardRef as ReactComponent };